(function () {
    "use strict";
    angular.module("app.common").directive("circlebar", circlebar);

    function circlebar() {
        var directive = {
            controller: [
                "$scope",
                controller,
            ],
            templateUrl: "/app/common/circlebar.directive.html",
            restrict: "EA",
            scope: {
                size: '@', //string - "md", "lg", "sm"
                value: '<',
                color: '@',
                background: '@'
            }
        };

        return directive;

        function controller($scope) {
            // Define investment color palette
            var investmentColors = {
                investmentVeryLow: '#FF4444',    // Very Low - Bright Red
                investmentLow: '#FF8800',        // Low - Orange
                investmentMedium: '#FFD700',     // Medium - Yellow
                investmentGood: '#90EE90',       // Good - Light Green
                investmentPerfect: '#4CAF50'     // Perfect - Dark Green
            };

            // Color interpolation function
            function interpolateColor(color1, color2, factor) {
                var hex1 = color1.replace('#', '');
                var hex2 = color2.replace('#', '');

                var r1 = parseInt(hex1.substr(0, 2), 16);
                var g1 = parseInt(hex1.substr(2, 2), 16);
                var b1 = parseInt(hex1.substr(4, 2), 16);

                var r2 = parseInt(hex2.substr(0, 2), 16);
                var g2 = parseInt(hex2.substr(2, 2), 16);
                var b2 = parseInt(hex2.substr(4, 2), 16);

                var r = Math.round(r1 + (r2 - r1) * factor);
                var g = Math.round(g1 + (g2 - g1) * factor);
                var b = Math.round(b1 + (b2 - b1) * factor);

                return '#' + r.toString(16).padStart(2, '0') +
                    g.toString(16).padStart(2, '0') +
                    b.toString(16).padStart(2, '0');
            }

            // Gradient position calculation function
            function getVisualPosition(score) {
                if (score <= 40) {
                    return (score / 40) * 25;
                } else if (score <= 50) {
                    return 25 + ((score - 40) / 10) * 20;
                } else if (score <= 60) {
                    return 45 + ((score - 50) / 10) * 20;
                } else if (score <= 70) {
                    return 65 + ((score - 60) / 10) * 20;
                } else {
                    return 85 + ((score - 70) / 30) * 15;
                }
            }

            // Color calculation function
            function calculateIndicatorColor(point) {
                var position = getVisualPosition(point);

                if (position <= 25) {
                    // Between red (0%) and orange (25%)
                    var factor = position / 25;
                    return interpolateColor(
                        investmentColors.investmentVeryLow,
                        investmentColors.investmentLow,
                        factor
                    );
                } else if (position <= 45) {
                    // Between orange (25%) and yellow (45%)
                    var factor = (position - 25) / 20;
                    return interpolateColor(
                        investmentColors.investmentLow,
                        investmentColors.investmentMedium,
                        factor
                    );
                } else if (position <= 65) {
                    // Between yellow (45%) and light green (65%)
                    var factor = (position - 45) / 20;
                    return interpolateColor(
                        investmentColors.investmentMedium,
                        investmentColors.investmentGood,
                        factor
                    );
                } else if (position <= 85) {
                    // Between light green (65%) and dark green (85%)
                    var factor = (position - 65) / 20;
                    return interpolateColor(
                        investmentColors.investmentGood,
                        investmentColors.investmentPerfect,
                        factor
                    );
                } else {
                    // Above 85% - solid dark green
                    return investmentColors.investmentPerfect;
                }
            }

            // Add color calculation function to scope
            $scope.getIndicatorColor = function (value) {
                if ($scope.color) {
                    return $scope.color;
                }
                return calculateIndicatorColor(value || 0);
            };
        }
    }
})();
